export function toTitleCase(str) {
  return str
    .toLowerCase()
    .split(" ")
    .filter(w => w.trim().length > 0)
    .map(w => w[0].toUpperCase() + w.slice(1))
    .join(" ");
}